import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Input } from 'shared/components';

class PasswordInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showPassword: false,
      showCriteria: true,
    };

    this.onPasswordFocus = this.onPasswordFocus.bind(this);
    this.onPasswordBlur = this.onPasswordBlur.bind(this);
    this.togglePassword = this.togglePassword.bind(this);
  }

  onPasswordFocus() {
    if (this.props.hideCriteria) {
      return;
    }
    this.setState({
      showCriteria: true,
    });
  }

  onPasswordBlur() {
    // this.setState({
    //   showCriteria: false,
    // });
  }

  togglePassword() {
    this.setState({
      showPassword: !this.state.showPassword,
    });
  }

  render() {
    const showPassword = this.state.showPassword
      ? this.props.t('common.labels.hide')
      : this.props.t('common.labels.show');
    return (
      <Input
        autocomplete="false"
        size="w-100"
        type={this.state.showPassword ? 'text' : 'password'}
        name={this.props.name || 'password'}
        id={this.props.name || 'password'}
        addon={showPassword}
        value={this.props.value}
        label={this.props.label}
        placeholder={this.props.t(this.props.placeholder)}
        onChange={this.props.onChange}
        onFocus={this.onPasswordFocus}
        onBlur={this.onPasswordBlur}
        onAddonAction={this.togglePassword}
        errors={this.props.errors}
        required>
        <span
          className={`input-error text-small ${!this.state.showCriteria ? 'd-none' : 'd-block'}`}>
          {this.props.t('register.passwordCriteria')}
        </span>
      </Input>
    );
  }
}

PasswordInput.propTypes = {
  value: PropTypes.string.isRequired,
  hideCriteria: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  errors: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

PasswordInput.defaultProps = {
  label: '',
  errors: [],
  hideCriteria: false,
};

export default withTranslation()(PasswordInput);
